import { render, staticRenderFns } from "./SelectPhases.vue?vue&type=template&id=9397455e"
import script from "./SelectPhases.vue?vue&type=script&lang=js"
export * from "./SelectPhases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports